import React from 'react'

const Landing = () => {
  return (
    <div>
      <h1>Landing page</h1>
    </div>
  )
}

export default Landing
